import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../providers/AuthContext';
export function AuthGuard({ unauthorizedComponent, redirectTo = '/auth/login', loadingFallback }) {
    const { loggedIn, isInitialized } = useAuth();
    if (!isInitialized) {
        return loadingFallback;
    }
    if (loggedIn) {
        return _jsx(Outlet, {});
    }
    // Pokud je definovaná komponenta pro nepřihlášené uživatele, použij ji
    if (unauthorizedComponent) {
        return _jsx(_Fragment, { children: unauthorizedComponent });
    }
    // Jinak přesměruj na zadanou URL
    return _jsx(Navigate, { to: redirectTo, replace: true });
}
//# sourceMappingURL=auth-guards.js.map